module.exports = __webpack_public_path__ + "img/medRiskMarker.dd3b531f.svg";